import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ValidatorsService } from '@services/util/validators.service';
import { AdmUsuarioService } from '@services/admin/adm-usuario.service';
import { AppService } from '@services/app.service';
import { Util } from '@/utils/util';

@Component({
  selector: 'app-cambiar-contrasenia',
  templateUrl: './cambiar-contrasenia.component.html',
  styleUrls: ['./cambiar-contrasenia.component.scss']
})
export class CambiarContraseniaComponent {

  public myForm: FormGroup = this.fb.group({
    currentPassword: ['', [Validators.required, Validators.minLength(6)]],
    newPassword: ['', [Validators.required, Validators.minLength(6)]],
    confirmPassword: ['', [Validators.required]]
  }, {
    validators: [this.validatorsService.isFieldOneEqualFieldTwo('newPassword', 'confirmPassword')]
  });

  public hideCurrentPassword = true;
  public hideNewPassword = true;
  public hideConfirmPassword = true;

  constructor(
    private fb: FormBuilder,
    private validatorsService: ValidatorsService,
    private usuarioService: AdmUsuarioService,
    private appService: AppService,
    private util: Util,
    public dialogRef: MatDialogRef<CambiarContraseniaComponent>
  ) {}

  isValiField(field: string) {
    return this.validatorsService.isValidField(this.myForm, field);
  }

  getFieldError(field: string) {
    if (!this.myForm.controls[field]) return null;
    const errors = this.myForm.controls[field].errors || {};

    for (const key of Object.keys(errors)) {
      switch (key) {
        case 'required':
          return 'Este campo es requerido';
        case 'minlength':
          return `Mínimo ${errors['minlength'].requiredLength} caracteres.`;
        case 'notEqual':
          return 'Las contraseñas no coinciden';
        default:
          return null;
      }
    }
    return null;
  }

  submit() {
    if (this.myForm.invalid) {
      this.myForm.markAllAsTouched();
      return;
    }

    const usuario = JSON.parse(sessionStorage.getItem('usuario') || '{}');
    const idUsuario = usuario.id_usuario;

    if (!idUsuario) {
      this.util.errorMessage('No se pudo obtener el ID del usuario');
      return;
    }

    const payload = {
      currentPassword: this.myForm.controls.currentPassword.value,
      newPassword: this.myForm.controls.newPassword.value
    };

    this.usuarioService.changePassword(idUsuario, payload).subscribe({
      next: (data) => {
        if (data.success) {
          this.util.infoMessage('','Contraseña actualizada con éxito. Redireccionando al inicio de sesión para activar la nueva contraseña...',function(){});
          this.dialogRef.close({ success: true });

          // Cerrar sesión después de 2 segundos para que el usuario lea el mensaje
          setTimeout(() => {
            this.appService.logout();
          }, 2000);
        } else {
          this.util.errorMessage(data.message || 'Error al cambiar la contraseña');
        }
      },
      error: (error) => {
        this.util.errorMessage('Error al cambiar la contraseña');
      }
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
